export default {
  app: {
    logo: 'Логотип SkyRadar',
    notProvided: 'Не указано',
    contactFormSubject: 'Форма обратной связи: ',
  },
  landing: {
    title: 'SkyRadar',
    subtitle: 'Решение для обнаружения молний корпоративного уровня',
    description: 'SkyRadar предлагает комплексную платформу для обнаружения и мониторинга молний для предприятий и организаций. Наша передовая технология обеспечивает оповещения в реальном времени, детальную аналитику и беспрепятственную интеграцию с вашими существующими системами для защиты ваших активов, операций и персонала от опасностей молний.',
    features: {
      title: 'Ключевые особенности',
      subtitle: 'Изучите мощные функции, которые выделяют нашу платформу',
      map: 'Мониторинг в реальном времени',
      mapDescription: 'Отслеживайте удары молний в момент их возникновения с помощью нашей высокоточной системы обнаружения',
      filter: 'Расширенная аналитика',
      filterDescription: 'Получайте ценные сведения с помощью анализа исторических данных и настраиваемых отчетов',
      location: 'Мгновенные оповещения',
      locationDescription: 'Получайте немедленные уведомления, когда молния угрожает вашей области интересов',
      theme: 'Беспрепятственная интеграция',
      themeDescription: 'Подключайтесь к существующим системам и рабочим процессам для создания единого решения',
    },
    ctaButton: 'Скачать приложение',
    mobileApp: {
      title: 'Мобильное приложение SkyRadar',
      subtitle: 'Будьте защищены везде, где бы вы ни находились, с нашим мощным мобильным приложением',
      heading: 'Отслеживайте активность молний и оставайтесь в безопасности',
      description: 'Наше мобильное приложение предоставляет мгновенные уведомления об ударах молний в вашем районе, помогая вам принимать своевременные решения по безопасности, будь то поход в горы, кемпинг или отдых на природе на Балканах.',
      highlight: 'Отслеживайте активность молний в реальном времени и получайте немедленные уведомления, когда удары обнаружены рядом с вашим местоположением.',
      downloadIos: 'Скачать для iOS',
      downloadAndroid: 'Скачать для Android',
      comingSoon: 'Скоро',
    },
    benefits: {
      title: 'Почему стоит выбрать SkyRadar',
      reliability: 'Непревзойденная надежность',
      reliabilityDescription: 'Гарантия 99,9% времени безотказной работы с резервными системами для непрерывной работы',
      accuracy: 'Превосходная точность',
      accuracyDescription: 'Точная технология обнаружения с минимальным количеством ложных срабатываний',
      scalability: 'Полная масштабируемость',
      scalabilityDescription: 'От одного объекта до глобального корпоративного развертывания с постоянной производительностью',
      support: 'Специализированная поддержка',
      supportDescription: 'Круглосуточная техническая помощь от нашей команды экспертов',
    },
    testimonials: {
      title: 'Что говорят наши клиенты',
      client1: {
        quote: 'SkyRadar преобразил то, как мы управляем рисками, связанными с погодой, на наших объектах. Оповещения в реальном времени помогли нам предотвратить несколько потенциальных инцидентов.',
        author: 'Иван Смирнов',
        position: 'Директор по безопасности, Global Energy Corp'
      },
      client2: {
        quote: 'Возможности интеграции впечатляют. Мы подключили SkyRadar к нашим существующим системам безопасности всего за несколько дней, а не месяцев.',
        author: 'Мария Родригес',
        position: 'Технический директор, Industrial Solutions Inc.'
      },
      client3: {
        quote: 'Аналитика, предоставляемая SkyRadar, помогла нам оптимизировать наши графики обслуживания и повысить эффективность работы.',
        author: 'Дмитрий Чен',
        position: 'Менеджер по операциям, National Grid Services'
      }
    },
    pricing: {
      title: 'Гибкие решения для любых потребностей',
      description: 'Мы предлагаем индивидуальные пакеты, адаптированные к вашим конкретным требованиям и масштабам.',
      basic: 'Базовый',
      basicDescription: 'Для малого бизнеса и операций на одном объекте',
      professional: 'Профессиональный',
      professionalDescription: 'Для средних предприятий с несколькими местоположениями',
      enterprise: 'Корпоративный',
      enterpriseDescription: 'Для крупных организаций со сложными требованиями',
      contact: 'Свяжитесь с нами для получения информации о ценах',
      contactSales: 'Связаться с отделом продаж',
      mostPopular: 'Самый популярный',
    },
    about: {
      title: 'Возможности интеграции',
      description: 'Если вы хотите получать информацию о молниях или интегрироваться с вашими сервисами, мы предлагаем гибкие решения для любых потребностей. Наши API и инструменты интеграции позволяют легко подключить данные о молниях к вашим существующим системам.',
      mission: 'Мы стремимся сделать данные о молниях доступными для всех через простые и надежные интеграции с любыми сервисами и платформами.',
    },
    footer: {
      rights: 'Все права защищены',
      privacy: 'Политика конфиденциальности',
      terms: 'Условия использования',
      quickLinks: 'Быстрые ссылки',
      contactUs: 'Свяжитесь с нами',
      email: 'Электронная почта: info@skyradar.com',
    },
    partners: {
      title: 'Наши партнеры',
      subtitle: 'Мы гордимся сотрудничеством с этими организациями, которые делают нашу миссию возможной',
      icdsoft: 'ICDSoft',
      icdsoftDescription: 'Основной партнер по хостингу и инфраструктуре',
      firebrigade: 'FireBrigade1',
      firebrigadeDescription: 'Партнер по сотрудничеству с аварийными службами',
    },
    dataProcessing: {
      title: 'Мощная обработка данных',
      description1: 'Наша система обрабатывает сотни тысяч событий молний ежедневно по всему Балканскому региону, предоставляя данные в реальном времени и аналитику для защиты сообществ и природных ресурсов.',
      description2: 'С помощью передовых алгоритмов и специализированной инфраструктуры мы анализируем каждый удар молнии, чтобы определить его местоположение, интенсивность и потенциальные факторы риска, обеспечивая более быстрое время реагирования для аварийных служб.',
      feature1: 'Обработка в реальном времени более 100 000 событий ежедневно',
      feature2: 'Точное географическое картирование ударов молний',
      feature3: 'Автоматизированная система оценки рисков и уведомлений',
    },
    mobileAppFeatures: {
      feature1: 'Уведомления о ударах молний в реальном времени',
      feature1Description: 'Получайте оповещения, когда молния обнаружена рядом с вашим местоположением',
      feature2: 'Интерактивная карта молний с фильтрами',
      feature2Description: 'Визуализируйте активность молний с настраиваемыми фильтрами',
      feature3: 'Настраиваемый радиус оповещений и настройки',
      feature3Description: 'Установите предпочтительное расстояние для уведомлений и типы оповещений',
      feature4: 'Прогнозы погоды с оценкой риска молний',
      feature4Description: 'Планируйте свои мероприятия с прогнозами риска молний',
      feature5: 'Работает офлайн с кэшированными данными',
      feature5Description: 'Доступ к последним данным даже без подключения к интернету',
    },
    sensorInfrastructure: {
      title: 'Индивидуальная инфраструктура датчиков',
      description: 'Ищете индивидуальное решение для сбора данных с датчиков молний или метеостанций? Мы предоставляем комплексную настройку инфраструктуры для организаций, которым необходимы надежные системы сбора данных о молниях и погоде.',
      quote: 'От установки оборудования до сбора и анализа данных, наша команда экспертов разработает и внедрит индивидуальное решение, отвечающее вашим конкретным требованиям.',
      learnMore: 'Узнать больше',
      page: {
        hero: {
          title: 'Индивидуальные решения для инфраструктуры датчиков',
          subtitle: 'Обнаружение молний и мониторинг погоды, адаптированные к вашим потребностям',
          description: 'Ищете индивидуальное решение для сбора данных с датчиков молний или метеостанций? Наша команда обеспечивает комплексную настройку инфраструктуры, от установки оборудования до сбора и анализа данных.',
          contactButton: 'Связаться с нами сейчас'
        },
        benefits: {
          title: 'Почему стоит выбрать нашу инфраструктуру датчиков',
          subtitle: 'Мы предоставляем комплексные решения для организаций, которым необходимы надежные системы сбора данных о молниях и погоде',
          items: {
            lightningDetection: {
              title: 'Продвинутое обнаружение молний',
              description: 'Наши датчики обеспечивают точное обнаружение молний с высокой точностью и минимальным количеством ложных срабатываний.'
            },
            weatherMonitoring: {
              title: 'Комплексный мониторинг погоды',
              description: 'Отслеживайте температуру, влажность, скорость ветра, осадки и многое другое с нашими интегрированными метеодатчиками.'
            },
            integration: {
              title: 'Простая интеграция',
              description: 'Наша инфраструктура легко интегрируется с вашими существующими системами через стандартные API и протоколы.'
            },
            dataCollection: {
              title: 'Надежный сбор данных',
              description: 'Надежные решения для сбора и хранения данных гарантируют, что ваши данные всегда доступны, когда они вам нужны.'
            },
            analytics: {
              title: 'Аналитика в реальном времени',
              description: 'Обрабатывайте и анализируйте данные датчиков в реальном времени для быстрого принятия обоснованных решений.'
            },
            management: {
              title: 'Удаленное управление',
              description: 'Контролируйте и управляйте вашей сетью датчиков удаленно через нашу интуитивно понятную панель управления.'
            }
          }
        },
        process: {
          title: 'Наш комплексный процесс',
          subtitle: 'От консультации до внедрения и постоянной поддержки',
          steps: {
            step1: {
              title: 'Консультация и анализ требований',
              description: 'Мы начинаем с понимания ваших конкретных потребностей, проблем и целей. Наша команда экспертов будет работать с вами, чтобы определить оптимальную конфигурацию датчиков и настройку инфраструктуры для вашего случая использования.'
            },
            step2: {
              title: 'Разработка индивидуального решения',
              description: 'На основе ваших требований мы разрабатываем индивидуальное решение, которое включает выбор оборудования, сетевую архитектуру, протоколы сбора данных и интеграцию с вашими существующими системами.'
            },
            step3: {
              title: 'Внедрение и развертывание',
              description: 'Наша опытная команда занимается установкой и настройкой всех аппаратных и программных компонентов. Мы обеспечиваем правильную калибровку и тестирование для гарантии точного сбора данных.'
            },
            step4: {
              title: 'Интеграция данных и аналитика',
              description: 'Мы настраиваем конвейеры обработки данных, решения для хранения и аналитические инструменты для преобразования необработанных данных датчиков в действенные выводы. Индивидуальные панели и отчеты обеспечивают легкий доступ к вашим данным.'
            },
            step5: {
              title: 'Постоянная поддержка и обслуживание',
              description: 'Наши отношения не заканчиваются с развертыванием. Мы предоставляем комплексную поддержку, регулярное обслуживание и обновления системы, чтобы гарантировать, что ваша инфраструктура продолжает работать оптимально.'
            }
          }
        },
        useCases: {
          title: 'Отраслевые применения',
          subtitle: 'Наши решения для инфраструктуры датчиков обслуживают различные отрасли с конкретными потребностями',
          items: {
            energy: {
              title: 'Энергетический сектор',
              description: 'Защитите инфраструктуру генерации и распределения энергии от ударов молний и суровых погодных условий.'
            },
            aviation: {
              title: 'Авиация',
              description: 'Обеспечьте безопасные взлеты и посадки с точными данными о молниях и погоде для аэропортов.'
            },
            agriculture: {
              title: 'Сельское хозяйство',
              description: 'Оптимизируйте сельскохозяйственные операции с точными прогнозами погоды и предупреждениями о молниях.'
            },
            sports: {
              title: 'Спорт и отдых',
              description: 'Обеспечьте безопасность мероприятий и активностей на открытом воздухе с своевременными оповещениями о погоде и молниях.'
            }
          }
        },
        whyUs: {
          title: 'Почему стоит сотрудничать с нами',
          items: {
            expertise: {
              title: 'Отраслевой опыт',
              description: 'Наша команда имеет десятилетия совокупного опыта в метеорологии, технологии датчиков и науке о данных.'
            },
            trackRecord: {
              title: 'Проверенный послужной список',
              description: 'Мы успешно внедрили сети датчиков для организаций в различных отраслях по всему миру.'
            },
            technology: {
              title: 'Передовые технологии',
              description: 'Мы используем новейшие достижения в технологии датчиков, IoT и облачных вычислениях для предоставления превосходных решений.'
            },
            approach: {
              title: 'Индивидуальный подход',
              description: 'Мы не верим в универсальные решения. Каждая система, которую мы проектируем, адаптирована к вашим конкретным требованиям.'
            },
            support: {
              title: 'Постоянная поддержка',
              description: 'Наша преданная команда поддержки гарантирует, что ваша инфраструктура продолжает работать с максимальной производительностью.'
            }
          }
        },
        contact: {
          title: 'Свяжитесь с нами',
          subtitle: 'Заинтересованы в наших решениях для инфраструктуры датчиков? Свяжитесь с нами сегодня, чтобы обсудить ваши потребности.',
          email: 'Напишите нам напрямую по адресу',
          emailAddress: 'infrastructure@skyradar.com'
        }
      }
    },
    cta: {
      title: 'Готовы защитить свои активы от опасностей молний?',
      description: 'Свяжитесь с нашей командой сегодня, чтобы узнать, как SkyRadar может помочь вашей организации внедрить комплексную стратегию защиты от молний.',
      button: 'Свяжитесь с нами сейчас',
    },
    companyDescription: 'Решения для обнаружения и мониторинга молний корпоративного уровня для предприятий и организаций по всему миру.',
    thunderBG: {
      title: 'ThunderBG',
      subtitle: 'Волонтерский проект по сбору данных о молниях на Балканах',
      description: 'ThunderBG - это волонтерская инициатива, посвященная сбору данных о молниях в Балканском регионе. Наша миссия - предоставлять информацию о молниях в реальном времени, чтобы помочь пожарным службам быстро реагировать на потенциальные лесные пожары и помогать туристам оставаться в безопасности во время активного отдыха на природе.',
      viewDemo: 'Посмотреть демо',
    },
    getStarted: 'Начать',
  },
  header: {
    main: 'Главная',
    map: 'Карта',
    contact: 'Контакты',
    sensorInfrastructure: 'Инфраструктура датчиков',
    language: 'Язык',
    about: 'О нас',
  },
  contact: {
    title: 'Свяжитесь с нами',
    subtitle: 'Свяжитесь с нашей командой',
    description: 'Мы предоставляем комплексные решения для сбора данных с датчиков, анализа, разработки приложений и интеграций. Если у вас есть датчики, но нет инфраструктуры, мы можем помочь решить эту проблему.',
    form: {
      name: 'Имя',
      email: 'Электронная почта',
      company: 'Компания',
      message: 'Сообщение',
      subject: 'Тема',
      phone: 'Телефон (необязательно)',
      submit: 'Отправить',
      sending: 'Отправка вашего сообщения...',
      success: 'Спасибо за ваше сообщение! Мы свяжемся с вами в ближайшее время.',
      error: 'При отправке вашего сообщения произошла ошибка. Пожалуйста, попробуйте позже.',
      nameRequired: 'Пожалуйста, введите ваше имя',
      emailRequired: 'Пожалуйста, введите вашу электронную почту',
      emailInvalid: 'Пожалуйста, введите действительный адрес электронной почты',
      messageRequired: 'Пожалуйста, введите сообщение',
      subjectRequired: 'Пожалуйста, введите тему',
      notificationTitle: 'Новая заявка с формы обратной связи:',
      notificationName: 'Имя:',
      notificationEmail: 'Электронная почта:',
      notificationCompany: 'Компания:',
      notificationPhone: 'Телефон:',
      notificationSubject: 'Тема:',
      notificationMessage: 'Сообщение:',
    },
    services: {
      title: 'Наши услуги',
      dataCollection: 'Сбор данных',
      dataAnalysis: 'Анализ данных',
      aiDevelopment: 'Разработка ИИ',
      appDevelopment: 'Разработка приложений',
      integrations: 'Пользовательские интеграции',
    },
  },
  map: {
    title: 'Карта молний',
    legend: 'Легенда карты',
    lightning: 'Молния',
    recent: 'Молнии за последние 5 минут',
    medium: 'Молнии за последние 30 минут',
    old: 'Молнии старше 30 минут',
    helpTitle: 'Как пользоваться картой',
    helpText1: 'Используйте элементы управления справа для увеличения/уменьшения масштаба и определения вашего местоположения.',
    helpText2: 'Фильтруйте события молний по времени с помощью кнопки фильтра.',
    helpText3: 'Нажмите на значки молний для получения дополнительной информации о каждом ударе.',
    filter: 'Фильтр событий молний',
    timeRange: 'Временной диапазон',
    minutes10: 'Последние 10 минут',
    hour1: 'Последний час',
    hours6: 'Последние 6 часов',
    hours24: 'Последние 24 часа',
    apply: 'Применить',
    loading: 'Загрузка карты...',
    error: 'Ошибка загрузки данных. Пожалуйста, попробуйте снова.',
    noData: 'В этой области не найдено событий молний для выбранного временного диапазона.',
    controls: {
      zoomIn: 'Увеличить',
      zoomOut: 'Уменьшить',
      myLocation: 'Мое местоположение',
      info: 'Информация о карте',
      yourLocation: 'Ваше местоположение'
    },
    filters: {
      last10min: 'Последние 10 минут',
      lastHour: 'Последний час',
      last6hours: 'Последние 6 часов',
      last24hours: 'Последние 24 часа',
      filter: 'Фильтр',
      openFilters: 'Открыть фильтры',
      filterLightningEvents: 'Фильтр событий молний',
      closeFilters: 'Закрыть фильтры',
      currentFilter: 'Текущий фильтр',
      none: 'Нет',
      selectTimeRange: 'Выберите временной диапазон',
      cancel: 'Отмена',
      apply: 'Применить'
    }
  },
};
